import { render, staticRenderFns } from "./physiologyGraphicAvgStudentYoyo.vue?vue&type=template&id=04e015fa&"
import script from "./physiologyGraphicAvgStudentYoyo.js?vue&type=script&lang=js&"
export * from "./physiologyGraphicAvgStudentYoyo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports